import { render, staticRenderFns } from "./CallStatistics.vue?vue&type=template&id=8f9a3d7e&scoped=true&"
import script from "./CallStatistics.vue?vue&type=script&lang=js&"
export * from "./CallStatistics.vue?vue&type=script&lang=js&"
import style0 from "./CallStatistics.vue?vue&type=style&index=0&id=8f9a3d7e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f9a3d7e",
  null
  
)

export default component.exports